import { TFunction } from '@lyearn/i18n';
import { Flip2Outline, Trash2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';

export enum ImageMenuActions {
  Replace = 'Replace',
  Remove = 'Remove',
}

const getImageMenuItems = (t: TFunction) =>
  [
    {
      id: ImageMenuActions.Replace,
      label: t('Common:Actions.Replace'),
      EndIcon: Flip2Outline,
    },
    {
      id: ImageMenuActions.Remove,
      label: t('Common:Actions.Remove'),
      EndIcon: Trash2Outline,
      appearance: 'danger',
    },
  ] as ActionMenuItemType[];

export default getImageMenuItems;
